import { get, post, put, destroy } from '.';

export function GetEmployees(options = {}) {
	return get<any>(`/app/api/employees`, options);
}

export function FindEmployee(vid: string, options = {}) {
	return get<any>(`/app/api/employees/${vid}`, options);
}

export function GetAvailableEmployees(options = {}) {
	return get<any>(`/app/api/employees/available`, options);
}

export function CreateEmployee(options = {}) {
	return post<any>(`/app/api/employees`, options);
}

export function UpdateEmployee(id: string, options = {}) {
	return put<any>(`/app/api/employees/${id}`, options);
}

export function DestroyEmployee(id: string, options = {}) {
	return destroy<any>(`/app/api/employees/${id}`, options);
}

export function RestoreEmployee(id: string, options = {}) {
	return post<any>(`/app/api/employees/${id}/restore`, options);
}

export function SyncCampaignAlerts(id: string, options = {}) {
	return post<any>(`/app/api/employees/${id}/sync_campaign_alerts`, options);
}
